import React, { useState, useEffect } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import OrderDetailInfoTable from './OrderDetail/OrderDetailInfoTable'
import { GetOrderPaletInfoForOrderInfoTable } from '../../Helpers/OrderInfoHelper'
import { useTranslation } from 'react-i18next';
import BOLImagesComponent from './BOLImagesComponent';
import PercentagePieChart from './PercentagePieChart';
import { truncate } from '../../Helpers/generalHelper';
import { systemParameters } from '../../Config/constants';

export default function OrderPaletInfo(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [percentage, setPercentage] = useState(props.productionOrder.switchPercentage || 0);
    
    // Update local state when prop changes
    useEffect(() => {
        setPercentage(props.productionOrder.switchPercentage || 0);
    }, [props.productionOrder?.switchPercentage]);

    if (props.general.systemParameters !== undefined && props.general.systemParameters !== null) {
        var silos = JSON.parse(props.general.systemParameters.find(x => x.id === systemParameters.Silos).value).silos.map(x => ({ label: x.name, value: x.id }));
        var currentSilo = silos.find(s => s.value == props.productionOrder.defaultSilo);
    }

    return <div className={classes.orderInfo}>
        <div className={classes.header}>
            <div className={classes.leftHeader}>
                <div className={classes.orderno}>
                    {t("Client")}
                </div>
                <div className={classes.orderNumber} title={props.productionOrder.customerName}>
                    {props.productionOrder.customerName.length > 18 ? truncate(props.productionOrder.customerName, 18) + "..." : props.productionOrder.customerName}
                </div>
            </div>
            <div className={classes.middleHeader}>
                {props.user && currentSilo !== null && currentSilo !== undefined && (
                    <PercentagePieChart 
                        percentage={percentage}
                        editable={false}
                    />
                )}
                <BOLImagesComponent bolMetaData={JSON.parse(props.productionOrder.bolMetaData).find(x => x.MetaDataType === 1).MetaData}></BOLImagesComponent>
                
            </div>
            <div className={classes.rightHeader}>
                <div className={classes.orderno}>
                    {t("Line")}
                </div>
                <div className={classes.orderNumber}>
                    {props.productionOrder.machinePlannedCode}
                </div>
            </div>
        </div>
        <OrderDetailInfoTable rows={GetOrderPaletInfoForOrderInfoTable(props.productionOrder.bomOut[0], props.user.isAdministrator, currentSilo, props.productionOrder)}></OrderDetailInfoTable>
        {/* {
            props.user.isAdministrator && currentSilo !== null && currentSilo !== undefined && <div><b>{t('DefaultSIlo')}</b>{currentSilo.label}</div>
        }    
        {
            props.user.isAdministrator && currentSilo !== null && currentSilo !== undefined && <div><b>{t('DefaultSIlo')}</b>{props.productionOrder.switchPercentage}</div>
        }     */}
    </div>
}

const useStyles = makeStyles({
    orderInfo: {
        float: "left",
        paddingLeft: "30px",
        paddingRight: "10px",
        width: "100%",
        boxSizing: "border-box",
        display: 'flex',
        flexDirection: 'column',
        marginBottom: "20px"
    },
    orderno: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block",
        marginTop: "15px"
    },
    orderNumber: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        marginBottom: "10px"
    },
    orderTable: {
        display: "block"
    },
    nameCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        width: "120px"
    },
    infoCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
    },
    paper: {
        boxShadow: 'none'
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },
    },
    rightHeader: {
        textAlign: "right",
        width: "10%",
        float: "left"
    },
    middleHeader: {
        width: "50%",
        float: "left",
        height: "67px",
        paddingTop: "15px",
        paddingBottom: "8px",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        gap: "20px",
    },
    leftHeader: {
        width: "40%",
        float: "left"
    }
});